<script lang="ts" setup>
import ImageThumbnailItem from '@/components/ImageThumbnailsItem.vue'
import { useGalleryState } from '@/composables/useGalleryState'

const { gallery } = useGalleryState()

const emit = defineEmits<{
  (e: 'backToSwiper', index: number): void
}>()

const backToSwiper = (index: number) => {
  emit('backToSwiper', index)
}
</script>

<template>
  <div class="thumbnails">
    <image-thumbnail-item
      v-for="(image, index) in gallery.images"
      :key="index"
      :image="image"
      :index="index"
      @backToSwiper="backToSwiper"
    ></image-thumbnail-item>
  </div>
</template>
